import { queryOptions, useQuery } from '@tanstack/react-query';
import { Accordion } from '@ui-kit/components/Accordion/Accordion';
import type { HTMLAttributes } from 'react';
import { queryKeys } from '@/api/utils/queryKeys';
import AccordionStackItem from '@/components/AccordionStackItem';
import { PortableTextContent } from '@/components/shared';
import { cmsApi } from '@/integrations/sanity/api';

const termsAndConditionsQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.cms.termsAndConditions,
    queryFn: () => cmsApi.getTermsAndConditions(),
    staleTime: Infinity,
  });

const TermsAndConditionsAccordion = (props: Omit<HTMLAttributes<HTMLDivElement>, 'children'>) => {
  const { data: termsAndConditionsData } = useQuery(termsAndConditionsQueryOptions());

  if (!termsAndConditionsData) {
    return null;
  }

  return (
    <Accordion {...props}>
      {termsAndConditionsData.contentBlockGroup?.contentBlocks?.map(contentBlock => (
        <AccordionStackItem
          label={{ value: contentBlock.title ?? '', as: 'h2' }}
          spacing={24}
          key={contentBlock._key}
        >
          {!!contentBlock.body && <PortableTextContent value={contentBlock.body} />}
        </AccordionStackItem>
      ))}
    </Accordion>
  );
};

export default TermsAndConditionsAccordion;
